import { Platform, StyleSheet } from 'react-native';

import { initialWindowMetrics } from 'react-native-safe-area-context';

import { blackTransparent } from 'utils/colors';
import {
    heightPercentageToDP,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const insets = initialWindowMetrics?.insets;
const topInset = Platform.select({
    ios: insets?.top || 0,
    default: 0,
});

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: topInset + (isTablet ? 12 : 0),
        backgroundColor: blackTransparent(0.7),
    },
    webContent: {
        justifyContent: 'center',
        paddingBottom: 48,
        maxWidth: 480,
        alignSelf: 'center',
    },
    tabletContent: {
        alignSelf: 'center',
        maxWidth: 480,
    },
    description: {
        lineHeight: 24,
        marginHorizontal: isTabletOrWeb ? undefined : 16,
    },
    closeButton: {
        alignSelf: 'flex-end',
        marginTop: 12,
        marginRight: widthPercentageToDP(16, 44, 80),
    },
    closeIcon: {
        width: 24,
        height: 24,
    },
    title: {
        marginBottom: heightPercentageToDP(16),
    },
    contentNonBlocked: {
        marginTop: Platform.select({
            web: 0,
            default: heightPercentageToDP(57, 26),
        }),
    },
    contentBlocked: {
        justifyContent: 'center',
    },
    hiddenInput: {
        height: 0,
    },
    modal: { margin: 0 },
});

export default styles;
